var framework = {
    extend: function(o1, o2, preventOverwrite) {
        for (var prop in o2) {
            if (o2.hasOwnProperty(prop)) {
                if (preventOverwrite && o1.hasOwnProperty(prop)) {
                    continue;
                }
                o1[prop] = o2[prop];
            }
        }
    }
};

var xmlSlides = new XmlSlides();

function BrochureView() {
    // "use strict";
    var _this = this,
        gallery,
        urlRedirectParameter = {
            first: _getQueryParameter('r'),
            second: _getQueryParameter('rs')
        },
        hasFirstPage = viewConfig.check("hasFirstPage") && !isMobile,
        hasLastPage = viewConfig.check("hasLastPage"),
        hasAppPromoPage = viewConfig.check("hasAppPromoPage"),
        jsonData = {},
        _viewOptions,
        firstImgSlide,
        // $pageZones,
        viewTopPadding = 0,
        _currentState = {
            currentPage: 0,
            mode: 'single',
            defaultMode: 'single'
        },
        _relatedBrochureData,
        _relatedBrochureLoaded = false,
        _lazyLoadPageImgs = true; /* TODO fix lazy loading for double page images. */

    _viewOptions = {
        realViewportWidth: 0,
        useLargeImages: viewConfig.check('largeQuality'),
        largeImagesPixelTreshold: 1100,
        largeImagesScaleTreshold: 0.8,

        // useLargeImages: viewConfig.check('largeQuality'),
        // loadLargeImages: true,
        firstResize: true,
        imageSrcWillChange: false,
        isInitialZoomed: false
    };

    /* Selector variables */
    var _viewHeaderSel = '.vr-header',
        _mainSel = '#main';

    _this.gallery = gallery;

    function _roundBy(value, digitsAfterDecimal) {
        var roundBase = Math.pow(10, digitsAfterDecimal) || 100;

        return Math.round(value * roundBase) / roundBase;
    }

    function _registerModule(name, module) {
        framework.extend(self, module.publicMethods);
        _modules.push(name);
    }

    function _isDoubleMode(item) {
        return _currentState.mode == ViewConsts.double;
        var currItem = item || gallery.currItem,
            isDoublePageSlide = currItem.doublePageSlide === true;

        return isDoublePageSlide;
    }

    function _isAtStart() {
        return gallery.getCurrentIndex() === 0;
    }

    //includes subscribe pages
    function _isAtEnd() {
        return gallery.getCurrentIndex() === gallery.items.length - 1;
    }

    // function _isAtOriginalEnd(){
    //     return gallery.getCurrentIndex() == _getOriginalLastPageInx();
    // }

    function _getOriginalLastPageInx() {
        var lastBrochurePageInx;

        if (_currentState.mode === ViewConsts.double) {
            lastBrochurePageInx = jsonData.originalItems.length / 2;
        } else {
            lastBrochurePageInx = jsonData.originalItems.length - 1;
        }

        return Math.floor(lastBrochurePageInx);
    }

    function _errorCallback(err) {
        console.log("ajax error: ", err);
    }

    function _isHtmlZoomableSlide(item) {
        var res = false;

        if (typeof item.html !== 'undefined') {
            for (var i = 0, len = gallery.options.allowZoomHtmlKeys.length; i < len; i++) {
                var zKey = gallery.options.allowZoomHtmlKeys[i];

                if (typeof item[zKey] !== 'undefined') {
                    res = true;
                    break;
                }
            }
        }

        return res;
    }

    var el = document.querySelectorAll('.pswp')[0];

    function _getImgSizeKey(forceLargeImg) {
        return _viewOptions.useLargeImages || forceLargeImg || (typeof gallery !== 'undefined' && gallery.currItem.largeZoomed) ? ViewConsts.largeImage : ViewConsts.mediumImage;
    }

    function _getQueryParameter(paramName) {
        var searchString = window.location.search.substring(1),
            i, val, params = searchString.split("&");

        for (i = 0; i < params.length; i++) {
            val = params[i].split("=");
            if (val[0] == paramName) {
                return val[1];
            }
        }
        return null;
    }

    function _urlHasRedirectParam(url) {
        var has = false;

        if (urlRedirectParameter.first || urlRedirectParameter.second) {
            has = true;
        }

        return has;
    }

    function _isAtRedirectablePage(index) {
        var hit, hitSecond;

        /*TODO double mode*/
        if (false /*gallery.isDoubleMode()*/ ) {
            hit = viewSettings.redirectAt.double;
            hitSecond = viewSettings.redirectAt.secondDouble;
        } else {
            hit = viewSettings.redirectAt.single;
            hitSecond = viewSettings.redirectAt.secondSingle;
        }

        return (index == hit && index ? 1 : (index == hitSecond && !isMobile ? 2 : false));
    }

    function _redirectToNextPage(index, redirectPage) {
        var
            // pageNumber  = _isDoubleMode() ? index/2 : index,
            pageNumber = index,
            location = window.location,
            url = location.protocol + "//" + location.host + location.pathname,
            redirectPart = redirectPage === 2 ? "rs" : "r";
        redirect = "?" + redirectPart + "=" + Math.floor(Math.random() * 1000) + 1;

        if (_isDoubleMode()) {
            pageNumber *= 2;
        } else {
            // if(!isMobile){
            // pageNumber += 1;
            // }
        }

        /*TODO ad redirect case*/
        // var adInx       = _adLayerIndex ? (_isDoubleMode() ? _adLayerIndex.double : _adLayerIndex.single) : _adLayerIndex;


        // /* if ad dont redirect */
        // if (index === adInx) return false;

        if (window.location.search.indexOf("rs=") > -1) {
            return false;
        }

        /* Check if was redirected before */
        if (_urlHasRedirectParam(location.href) && redirectPage != 2) {
            return false;
        }

        if (_isDoubleMode()) {
            if (_isAtEnd()) { pageNumber = index * 2; }
        } else {
            if (_isAtEnd()) {
                return false;
            } else {

                if (index === gallery.items.length - 2 && hasLastPage) {
                    return false;
                }
            }
        }

        var hash = "#page=" + pageNumber;

        window.location.href = url + redirect + hash;

        return true;
    }

    function _redirectIfNeeded(currInx) {
        var redirectPage = _isAtRedirectablePage(currInx);

        if (redirectPage) {
            redirectInAction = _redirectToNextPage(currInx, redirectPage);
        }
    }

    function _getData(url, callback) {
        $.ajax({
            url: url,
            type: "GET",
            dataType: 'json',
            success: callback,
            error: _errorCallback
        });
    }

    function _translateObjects(items) {
        if (typeof items !== 'undefined' && items !== null && items.images && items.images.length) {
            var newItems = Array(items.images.length),
                images = items.images;


            for (var i = 0, len = images.length; i < len; i++) {
                newItems[i] = {};

                if (typeof images.thumbs[(i == 24 ? 25 : i)] !== 'undefined') {
                    newItems[i].thumbImage = {
                        src: images.thumbs[i].src,
                        w: parseInt(images.thumbs[i].width),
                        h: parseInt(images.thumbs[i].height),
                        pid: parseInt(i),
                    };
                } else {
                    newItems[i].thumbImage = { src: "", w: 0, h: 0, pid: 0 };
                    // console.log('Warning, thumbImage for index "' + i + '" is missing.');
                }

                if (typeof images.medium[i] !== 'undefined') {
                    newItems[i].mediumImage = {
                        src: images.medium[i].src,
                        w: parseInt(images.medium[i].width),
                        h: parseInt(images.medium[i].height),
                        pid: parseInt(i),
                    };
                } else {
                    newItems[i].mediumImage = { src: "", w: 0, h: 0, pid: 0 };
                    // console.log('Warning, mediumImage for index "' + i + '" is missing.');
                }

                if (typeof images.large[i] !== 'undefined') {
                    newItems[i].largeImage = {
                        src: images.large[i].src,
                        w: parseInt(images.large[i].width),
                        h: parseInt(images.large[i].height),
                        pid: parseInt(i),
                    };

                    newItems[i].additional_page = images.large[i].additional_page;
                } else {
                    newItems[i].largeImage = { src: "", w: 0, h: 0, pid: 0 };
                    // console.log('Warning, largeImage for index "' + i + '" is missing.');
                }

                newItems[i].pins = items.extensions.pins[i] || [];
                newItems[i].inx = i;
            }

            return newItems;
        }
    }

    function _getCurrentPage() {
        var page;

        page = parseInt(window.location.hash.replace("#page=", ""));
        page = page ? page : 0;

        page = _getIndexByPage(page);

        return page;
    }

    function _ifPageExists(index) {
        return (index >= 0 && index < _this.jsonData[_currentState.mode + "PageItems"].length);
    }

    function _getIndexByPage(page) {
        var index = 0;

        if (_isDoubleMode()) {
            index = Math.ceil(page / 2);
        } else {
            index = page;
        }

        return _ifPageExists(index) ? index : 0;
    }

    function _handleImageMaps() {
        if (_isHtmlSlide() === false || gallery.currItem.container && gallery.currItem.container.querySelectorAll('map').length == 0) {
            return;
        }

        $('#promo-last-page map').imageMapResize();
    }

    function _isHtmlSlide() {
        return typeof gallery.currItem.html !== 'undefined';
    }

    function _generateFrontCover() {
        var frontCover = {
            cover: true,
            w: 793,
            h: 1000,
            html: '<div id="front-cover" class="html-slide cover-slide"></div>'
        };

        return frontCover;
    }

    function _generateBackCover(relatedBrochures) {
        var relatedHtml = "";

        $.each(relatedBrochures, function(inx, related) {
            relatedHtml += '<img src="' + related.url + '" alt="' + related.alt + '" />';
        });

        var backCover = {
            cover: true,
            w: 793,
            h: 1000,
            html: '<div id="back-cover" class="html-slide cover-slide"></div>'
        };

        return backCover;
    }

    function _generatePromoLastPage(promoData) {
        if (!promoData) {
            return false;
        }

        // var promoLastPage = {
        //     appPromoSlide: true,
        //     w: promoData.w,
        //     h: promoData.h,
        //     html: '<div id="promo-last-page" class="html-slide app-promo-slide">' +
        //         '<img src="' + promoData.src + '" class="page-img" usemap="#view-app-promo">' +
        //         promoData.map.html +
        //         '</div>',
        //     map: promoData.map
        // };

        return promoData;
    }

    function _generateRelatedHtmlFromJson(startInx, endInx) {
        var relatedHtml = '';
        
        $.each(jsonData.relatedBrochures, function(inx, item) {
            if (inx < startInx || inx > endInx) {
                return true;
            }

            var relatedItem =
                '<article class="catalog" data-brochure-id="' + item.id + '" data-offerista-id="' + (item.offerista_id ? item.offerista_id : '') + '">' +
                '<header class="catalog-header">' +
                '<h2 class="catalog-title">' + item.brand_name +
                '<span class="opacity"><span></span><span></span><span></span><span></span><span></span></span>' +
                '</h2>' +
                '</header>' +
                '<div class="catalog-cover">' +
                '<div class="catalog-image">';

            if (typeof viewSettings.viewedBrochures !== 'undefined' && item.id in viewSettings.viewedBrochures) {
                // relatedItem += '<ins class="catalog-chrono-tag">' + viewLang.brochure_viewed + '</ins>';
            }
            relatedItem += '<div class="catalog-mask">';
            if (item.campaign_link) {
                var aEl = document.createElement('a');
                aEl.setAttribute('onclick', "ga('send', 'event', { eventCategory: 'Cover', eventAction: '" + item.campaign_link + "'});");
                aEl.setAttribute('href', item.campaign_link);
                aEl.setAttribute('target', '_blank');

                aEl.className = 'catalog-buttons';

                aEl.innerHTML = '<div class="next-brochure">' +
                    '<span class="next-brochure button button-primary">' +
                    viewLang.html_see_more +
                    '</span>' +
                    '</div>';

                relatedItem += aEl.outerHTML;
            } else {
                relatedItem += '<a href="' + item.brochure_link + '?related=back" class="catalog-buttons">';
                relatedItem += '<div class="next-brochure">' +
                    '<span class="next-brochure button button-primary">' +
                    viewLang.html_see_more +
                    '</span>' +
                    '</div>' +
                    '</a>';
            }

            relatedItem += '</div>' +
                '<div class="catalog-border">' +
                '<img src="' + item.cover + '" alt="' + item.brand_name + '">' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</article>';

            relatedHtml += relatedItem;
        });

        return relatedHtml;
    }

    function _generateRelatedForBackCover() {
        var relatedHtml = _generateRelatedHtmlFromJson(0, 11);

        $('.view-related').html(relatedHtml);
    }

    function _generateRelatedForBackCoverSecond() {
        var relatedHtmlSecond = _generateRelatedHtmlFromJson(12, 27);
        $('.view-related').append(relatedHtmlSecond);
    }

    function _generateRelatedForRelatedPage() {
        var relatedHtml = '<div class="cover-inner cover related-brochures-page">';

        relatedHtml += _generateRelatedHtmlFromJson(12);
        relatedHtml += '</div>';

        return relatedHtml;
    }

    function _generateRelatedBrochuresPage() {
        if (typeof jsonData.relatedBrochures !== 'undefined' && jsonData.relatedBrochures.length) {
            var page,
                relatedHtml = _generateRelatedForRelatedPage();

            page = {
                slideType: ViewConsts.relatedSlide,
                // w: 952,
                // h: 1500,
                w: 793,
                h: 1000,
                html: relatedHtml,
                blockZoom: true
            };

            return page;
        }

        return undefined;
    }

    function _generateSpecificPromoLastPage(promoData) {
        if (typeof promoData === 'undefined' || !promoData) {
            return false;
        }

        var promoPage = {
            appPromoSlide: true,
            w: promoData.w,
            h: promoData.h,
            html: '<div id="promo-last-page" class="html-slide app-promo-slide specific-promo-page">' +
                '<img src="' + promoData.src + '" class="page-img" usemap="#view-specific-promo">' +
                promoData.map.html +
                '</div>',
            map: promoData.map
        };

        return promoPage;
    }

    function _findFirstUnreadRelatedBrochure(jsonData) {
        if (typeof jsonData.relatedBrochures !== 'undefined' && jsonData.relatedBrochures.length > 0) {
            viewSettings.relatedBrochure = jsonData.relatedBrochures[0];
        }

        $.each(jsonData.relatedBrochures, function(inx, item){
            if((typeof viewSettings.viewedBrochures !== 'undefined' && item.id in viewSettings.viewedBrochures == false) || (typeof viewSettings.viewedBrochures === 'undefined')){
                if(typeof item.skip_brochure !== 'undefined' && item.skip_brochure){
                    //Continue to next brochure as current is with outlink
                    console.log('skipping rel because of skip_brochure');
                    return true;
                }

                viewSettings.relatedBrochure = item;
                return false; //break the loop
            }
        });
    }

    function _createPageElem(src, imgPageInx, isRelated, alt) {
        var img = document.createElement('img');

        img.alt = alt || '';
        img.className = 'slide-img b-lazy';

        if (imgPageInx == 0 || _lazyLoadPageImgs === false) {
            img.src = src;
        } else {
            img.setAttribute('data-src', src);
        }

        img.setAttribute('data-page-inx', imgPageInx);

        if (isRelated) {
            img.setAttribute('data-related-brochure', 'true');
        }

        return img;
    }

    function _generateDoubleModeSlides(items, isRelatedBrochure, forceLargeImg) {
        var pageArr = [];
        var imgSizeKey = _getImgSizeKey(forceLargeImg);

        for (var i = 0, len = items.length; i < len; i++) {
            var page = { doublePageSlide: true, w: 0, h: 0, originalSize: { w: 0, h: 0 }, pagesSize: [] },
                page0Html = '',
                page1Html = '',
                img0 = 0,
                img1 = 0,
                img0W = 0,
                img1W = 0,
                img0H = 0,
                img1H = 0,
                currItem = null,
                isRelated = isRelatedBrochure ? ' data-related-brochure="true" ' : "";

            currItem = items[i];

            img0 = currItem[0];
            img1 = currItem[1];

            if (img0.hasOwnProperty('html')) {
                page0Html = img0.html;
                img0W = img0.w;
                img0H = img0.h;
            } else {
                page0Html = _createPageElem(img0[imgSizeKey].src, img0.inx, isRelated);
                img0W = img0[imgSizeKey].w;
                img0H = img0[imgSizeKey].h;
            }

            page.pagesSize.push({ w: img0W, h: img0H });

            var wRatio = 1,
                hRatio = 1,
                img0ScaledW = img0W,
                img0ScaledH = img0H,
                img1ScaledW = 0,
                img1ScaledH = 0,
                img0Classes = '', // Set width or height to auto, so that image is not stretched
                img1Classes = '';

            if (typeof img1 !== 'undefined') {
                if (img1.hasOwnProperty('html')) {
                    page1Html = img1.html;
                    img1W = img0.hasOwnProperty('html') === false ? img0W : img1.w;
                    img1H = img0.hasOwnProperty('html') === false ? img0H : img1.h;
                } else {
                    img1W = img1[imgSizeKey].w;
                    img1H = img1[imgSizeKey].h; //TODO get medium image size or current image size
                    img1ScaledW = img1W;
                    img1ScaledH = img1H;

                    page1Html = _createPageElem(img1[imgSizeKey].src, img1.inx, isRelated);

                    if (img0.hasOwnProperty('html') && (img0H < img1H)) {
                        img0H = img1H;
                        img0W = img1W;
                    }

                    if (img1H > img0H) {
                        wRatio = _roundBy(img0W / img1W, 3);
                        hRatio = _roundBy(img0H / img1H, 3);

                        img1ScaledW = _roundBy(img1W * hRatio, 0);
                        img1ScaledH = _roundBy(img1H * hRatio, 0);

                    } else if (img0H > img1H) {
                        wRatio = _roundBy(img1W / img0W, 3);
                        hRatio = _roundBy(img1H / img0H, 3);

                        img0ScaledW = _roundBy(img0W * hRatio, 0);
                        img0ScaledH = _roundBy(img0H * hRatio, 0);

                    }

                    img0Classes += " width-auto ";
                    img1Classes += " width-auto ";
                }

                page.pagesSize.push({ w: img1W, h: img1H });
            }

            if (!img1W) {
                img1ScaledH = img0H;
            }

            if (img0[imgSizeKey]) {
                page0Html.className += img0Classes;
            }

            if (img1 && img1[imgSizeKey]) {
                page1Html.className += img1Classes;
            }

            /* end of stretch check*/
            if (img1ScaledW == img1W) {
                page.w = (img0.cover ? img1W : Math.max(img0ScaledW, img1W)) * 2;
            } else {
                page.w = (img0.cover ? img1W : Math.max(img0W, img1ScaledW)) * 2;
            }

            if (img1ScaledH == img1H) {
                page.h = Math.max(img0ScaledH, img1H);
            } else {
                page.h = Math.max(img0H, img1ScaledH);
            }

            var pageWrapElem = document.createElement('div');
            pageWrapElem.className = "html-slide double-page-slide";

            if (i === len - 1 && typeof img1 === 'undefined') { //Check if last page is cover/html page, so that it is shown centered
                page.w = Math.max(img0W, img1W);
                page1Html = 0;

                if (typeof page0Html === 'string') {
                    // pageWrapElem = page0Html;
                    var dF = document.createElement('div');
                    dF.innerHTML = page0Html;
                    pageWrapElem.appendChild(dF.children[0]);

                } else {
                    pageWrapElem.appendChild(page0Html);
                }

            } else {
                var page0Wrap = document.createElement('div'),
                    page1Wrap = document.createElement('div'),
                    page0InnerWrap = document.createElement('div'),
                    page1InnerWrap = document.createElement('div');

                page0Wrap.className = 'page page-0';
                page0Wrap.setAttribute('data-slot-inx', 0);

                page1Wrap.className = 'page page-1';
                page1Wrap.setAttribute('data-slot-inx', 1);

                page0InnerWrap.className = 'page-inner-wrap';
                page1InnerWrap.className = 'page-inner-wrap';

                page0Wrap.appendChild(page0InnerWrap);
                page1Wrap.appendChild(page1InnerWrap);

                if (typeof page0Html === 'string') {
                    var dF = document.createElement('div');

                    dF.innerHTML = page0Html;
                    page0InnerWrap.appendChild(dF.children[0]);

                    if (page0InnerWrap.querySelectorAll('.app-promo-slide').length > 0 || page0InnerWrap.querySelectorAll('#back-cover').length > 0) {
                        page0InnerWrap.className += ' width-100 ';
                    }
                } else {
                    page0InnerWrap.appendChild(page0Html);
                }

                if (typeof page1Html === 'string') {
                    var dF = document.createElement('div');

                    dF.innerHTML = page1Html;
                    page1InnerWrap.appendChild(dF.children[0]);

                } else {
                    page1InnerWrap.appendChild(page1Html);
                }

                pageWrapElem.appendChild(page0Wrap);
                pageWrapElem.appendChild(page1Wrap);

                if (items[i][0].blockZoom || (items.length > 1 && items[i][1].blockZoom)) {
                    pageWrapElem.className += ' ' + ViewConsts.blockZoomClass + ' ';
                }
            }

            page.html = pageWrapElem;

            page.originalSize.w = page.w;
            page.originalSize.h = isNaN(page.h) ? 0 : page.h;

            pageArr.push(page);
        }


        return pageArr;
    }

    function _renderNextBrochure(relatedData, nextId) {
        if (!isMobile) {
            return;
        }

        var relatedSlide;

        if (relatedData.type == ViewConsts.xml) {
            _relatedBrochureData = xmlSlides.getXmlData(relatedData);
        } else {
            _relatedBrochureData = _translateObjects(relatedData);
        }

        _relatedBrochureData = _relatedBrochureData.slice();
        _this.relatedBrochureData = _relatedBrochureData;

        jsonData.relatedBrochure = {
            id: nextId,
            mode: relatedData.mode,
            originalItems: _relatedBrochureData,
            singlePageItems: [],
            doublePageItems: []
        };

        if (relatedData.type == ViewConsts.xml) {
            jsonData.relatedBrochure.type = ViewConsts.xml;
            jsonData.relatedBrochure.singlePageItems = xmlSlides.buildSingleContent(_relatedBrochureData.slice(), false, false, false, false, false);
        } else {
            jsonData.relatedBrochure.singlePageItems = _buildSingleContent(_relatedBrochureData.slice(), false, false, false, true, false);
            // jsonData.relatedBrochure.doublePageItems = _buildDoubleContent(_relatedBrochureData.slice(), false, false, false, true, false);
        }

        relatedData.mode = _currentState.mode;
        relatedSlide = relatedData.mode === ViewConsts.single ? jsonData.relatedBrochure.singlePageItems[0] : jsonData.relatedBrochure.doublePageItems[0];
        relatedSlide.skipPins = true;

        gallery.items.splice(gallery.items.length, 0, relatedSlide);
        gallery.invalidateCurrItems();
        gallery.updateSize(true);

        _relatedBrochureLoaded = true;
    }

    function _loadNextBrochure(nextId) {
        _getData(catalogDataUrl + nextId, function(relatedData) {
            _renderNextBrochure(relatedData, nextId);
        });
    }

    function _calcHtmlSlideSize() {
        if ($('#view-main-wrapper.inited').length == 0 || (gallery.currItem.container && gallery.currItem.container.querySelectorAll(' * .slide-img, .html-slide').length == 0)) {
            return;
        }

        var _tempPanAreaSize = {},
            currItem = gallery.currItem,
            item, //TODO cache state of image quality and use it here
            setNewImgSize = false;


        if (_isHtmlZoomableSlide(currItem) || jsonData.type === ViewConsts.xml) {
            if (typeof currItem.originalSize !== 'undefined') {
                item = currItem.originalSize;
            } else {
                item = currItem;
            }
        } else {
            firstImgSlide = _firstImgSlide(gallery);

            if (firstImgSlide && typeof firstImgSlide.originalSize !== 'undefined') {
                item = firstImgSlide.originalSize;
            } else {
                item = firstImgSlide[_getImgSizeKey()];
            }
        }

        _tempPanAreaSize.x = gallery.viewportSize.x;
        _tempPanAreaSize.y = gallery.viewportSize.y - viewTopPadding;

        if (gallery.currItem.w != item.w) {
            // console.log('%c set original page size', 'color: orange');
            setNewImgSize = true;
        }

        var hRatio = _tempPanAreaSize.x / item.w;
        var vRatio = _tempPanAreaSize.y / item.h;

        var fitRatio = hRatio < vRatio ? hRatio : vRatio;
        var w = item.w * fitRatio;
        var h = item.h * fitRatio;

        gallery.currItem.w = item.w;
        gallery.currItem.h = item.h;

        if (gallery.currItem.container && setNewImgSize) {
            gallery.updateSize(true);
        }
    }

    function _firstImgSlide(gallery) {
        // console.log('_firstImgSlide');
        if (typeof firstImgSlide !== 'undefined') {
            return firstImgSlide;
        }
        // TODO check if this funciton is obsolete.
        var imgSlide;

        for (var i = 0, len = gallery.items.length; i < len; i++) {
            var el = gallery.items[i];

            if (typeof el !== 'undefined' && typeof el.html === 'undefined') {
                imgSlide = el;
                break;
            }
        }

        return imgSlide;
    }

    function _replaceGalleryItems(items, mode) {
        gallery.items.splice(0, gallery.items.length);

        for (var i = 0, len = items.length; i < len; i++) {
            gallery.items.splice(i, 0, items[i]);
        }

        //Set this as items reinit with medium size in double page, upon switching modes.
        gallery.currItem.largeZoomed = false;

        gallery.invalidateCurrItems();
        gallery.updateSize(true);
    }

    function _switchMode() {

        //_currentState.mode = (_currentState.mode === ViewConsts.double) ? ViewConsts.single : ViewConsts.double;

        //if (_currentState.mode == ViewConsts.single) {
            _switchToSingleMode();
        // } else {
        //     _switchToDoubleMode();
        // }
    }

    function _switchToSingleMode() {

        _currentState.mode = 'single';
        jsonData.images = jsonData.singlePageItems.slice();

        _replaceGalleryItems(jsonData.singlePageItems.slice(), ViewConsts.single);
        gallery.goTo(gallery.getCurrentIndex() * 2 - 1);


        fireEvent(window, 'view.onmodechange', _currentState.mode);
        fireEvent(window, 'view.onpagechange');
    }

    function _switchToDoubleMode() {

        _currentState.mode = 'double';
        jsonData.images = jsonData.doublePageItems.slice();

        _replaceGalleryItems(jsonData.doublePageItems.slice(), ViewConsts.double);
        gallery.goTo(Math.round(gallery.getCurrentIndex() / 2));


        fireEvent(window, 'view.onmodechange', _currentState.mode);
        fireEvent(window, 'view.onpagechange');
    }

    function _buildSingleContent(data, frontCover, backCover, promoLastPage, isRelatedBrochure, promoSpecificLastPage) {
        var dataArr = [];

        dataArr = dataArr.concat(data);

        if (hasAppPromoPage && promoLastPage) {
            dataArr.push(promoLastPage);
        }

        if (typeof specificPromoPage !== 'undefined' && specificPromoPage && promoSpecificLastPage) {
            dataArr.push(promoSpecificLastPage);
        }

        if (hasLastPage && backCover) {
            dataArr.push(backCover);
        }

        return dataArr;
    }

    function _buildDoubleContent(data, frontCover, backCover, promoLastPage, isRelatedBrochure, promoSpecificLastPage) {
        var dataArr = [],
            layersCnt = data.length / 2,
            innerInx = 0,
            pageArr = [],
            dLen = data.length,
            doubleSlides;

        if (layersCnt % 2 !== 0) {
            layersCnt = Math.round(layersCnt);
        }

        if (layersCnt === 0) {
            layersCnt = 1;
        }

        if (hasFirstPage && frontCover) {
            dataArr = [
                [frontCover, data[0]]
            ];
            innerInx++;
        }

        for (var i = 0; i < layersCnt && innerInx < dLen; i++) {
            pageArr = [data[innerInx]];

            if (innerInx + 1 < dLen) {
                pageArr.push(data[innerInx + 1]);
            }

            dataArr.push(pageArr);
            innerInx += 2;
        }


        if (hasAppPromoPage && promoLastPage) {
            var lastPageSlidesCnt = dataArr[dataArr.length - 1].length;

            if (lastPageSlidesCnt == 1) {
                dataArr[dataArr.length - 1].push(promoLastPage);
            } else {
                dataArr.push([promoLastPage]);
            }
        }

        if (typeof specificPromoPage !== 'undefined' && specificPromoPage && promoSpecificLastPage) {
            var lastPageSlidesCnt = dataArr[dataArr.length - 1].length;

            if (lastPageSlidesCnt == 1) {
                dataArr[dataArr.length - 1].push(promoSpecificLastPage);
            } else {
                dataArr.push([promoSpecificLastPage]);
            }
        }

        if (hasLastPage && backCover) {
            var lastPageSlidesCnt = dataArr[dataArr.length - 1].length;

            if (lastPageSlidesCnt == 1) {
                dataArr[dataArr.length - 1].push(backCover);
            } else {
                var relatedPage = _generateRelatedBrochuresPage();
                if (typeof relatedPage !== 'undefined') {
                    dataArr.push([backCover, relatedPage]);
                } else {
                    dataArr.push([backCover]);
                }
            }
        }

        doubleSlides = _generateDoubleModeSlides(dataArr, isRelatedBrochure);

        return doubleSlides;
    }

    function _checkIfOnlyCover(item) {
        var currInx = gallery.getCurrentIndex();

        return jsonData.doublePageItems[currInx].length == 1 && typeof jsonData.doublePageItems[currInx][0].html !== 'undefined';
    }

    function _hideFrontCover() {
        $('#cover-front').hide();
    }

    var hideFrontCoverTimeout;
    var hideBackCoverTimeout;

    function _handleFrontCover(hideTimeParam, forceHide) {

        var $fcWrap = $('#front-cover'),
            fcSize,
            fcOffset,
            $visibleCf = $('#cover-front'),
            cssObj = {},
            pswpOffsetLeft = $('.pswp').offset().left,
            hideTime = typeof hideTimeParam !== 'undefined' ? hideTimeParam : 100;

        $visibleCf.stop();
        $('#back-cover').stop();

        if ((_isAtEnd() || (isMobile && _relatedBrochureLoaded && gallery.getCurrentIndex() == jsonData.singlePageItems.length - 1)) && gallery.currItem.container && gallery.currItem.container.querySelectorAll('.slide-img').length < 2) {
            if (gallery.getZoomLevel() === gallery.currItem.initialZoomLevel) {
                $('#back-cover').stop().fadeIn();
            } else {
                clearTimeout(hideBackCoverTimeout);

                if (hideTime != 0) {
                    hideBackCoverTimeout = setTimeout(function() {
                        if (!isMobile) {
                            $('#back-cover').stop().hide();
                        }
                    }, hideTime);
                } else {
                    if (!isMobile) {
                        $('#back-cover').stop().hide();
                    }
                }
            }
        }

        if (_isDoubleMode() !== true ||
            _isAtStart() !== true ||
            $fcWrap.length === 0 ||
            gallery.getZoomLevel() !== gallery.currItem.initialZoomLevel ||
            forceHide
        ) {
            // clearTimeout(hideFrontCoverTimeout);

            // if (hideTime != 0) {
            //     hideFrontCoverTimeout = setTimeout(function() {
            //         $visibleCf.hide();
            //     }, hideTime);
            // } else {
            //     $visibleCf.hide(0);
            // }
            return;
        }


        fcSize = $fcWrap.closest('.page')[0].getBoundingClientRect();
        fcOffset = $(gal.gallery.currItem.container).position();

        var fcNewLeft = fcSize.width > 340 ? fcSize.left : fcSize.left - (346 - fcSize.width);
        cssObj = { left: (fcNewLeft - pswpOffsetLeft) + 'px', width: fcSize.width + 'px' };
        cssObj.position = "absolute";
        cssObj.width

        if ($visibleCf.hasClass('cover-hidden')) {
            $visibleCf.removeClass('cover-hidden');
        }

        if ($visibleCf.is(':hidden') || $visibleCf.css('opacity') != '1') {
            $visibleCf.css(cssObj);
            $visibleCf.stop().fadeIn(300);
        } else {
            $visibleCf.css(cssObj);
        }
    }

    function _getScrollWrapBounds() {
        return document.querySelector('.pswp__scroll-wrap').getBoundingClientRect();
    }

    function _loadLargeImgIfMust() {
        // return early, when large images are disabled
        // if(_viewOptions.useLargeImages == false){
        //     return;
        // }

        var currZoom = gallery.getZoomLevel(),
            currItem = gallery.currItem,
            maxZoomScale = gallery.options.maxSpreadZoom;

        if (currItem.largeZoomed /*|| _viewOptions.useLargeImages == false*/ ) {
            return;
        }

        // console.log("%c _loadLargeImgIfMust::", "color: green", gallery.panOffset);

        if (currZoom >= maxZoomScale * _viewOptions.largeImagesScaleTreshold) {
            // console.log('_loadLargeImgIfMust load large');

            if (_isDoubleMode() === true) {
                var pages = gallery.currItem.container.querySelectorAll('.page .slide-img'),
                    largeImg = {},
                    largeZoom,
                    img0 = 0,
                    img1 = 0,
                    img0W = 0,
                    img1W = 0,
                    img0H = 0,
                    img1H = 0,
                    wRatio = 1,
                    hRatio = 1,
                    img0ScaledW = 0,
                    img0ScaledH = 0,
                    img1ScaledW = 0,
                    img1ScaledH = 0,
                    img0Classes = '', // Set width or height to auto, so that image is not stretched
                    img1Classes = '';


                if (pages.length) {
                    var page0Inx = pages[0].getAttribute('data-page-inx'),
                        page1Inx;

                    img0 = jsonData.originalItems[page0Inx];
                    img0W = img0ScaledW = img0.largeImage.w;
                    img0H = img0ScaledH = img0.largeImage.h;

                    pages[0].src = img0.largeImage.src;

                    largeImg.w = img0W;
                    largeImg.h = img0H;

                    if (pages.length == 2) {
                        page1Inx = pages[1].getAttribute('data-page-inx'),
                            img1 = jsonData.originalItems[page1Inx];
                        img1W = img1.largeImage.w;
                        img1H = img1.largeImage.h;
                        pages[1].src = img1.largeImage.src;

                        img1ScaledW = img1W;
                        img1ScaledH = img1H;

                        largeImg.w = Math.max(img0W, img1W) * 2;

                        if (img0W < img1W && img0H > img1H) {
                            largeImg.h = img1H;
                        } else if (img0W > img1W && img0H < img1H) {
                            largeImg.h = img0H;
                        } else {
                            largeImg.h = Math.max(img0H, img1H);
                        }
                    } else {
                        largeImg.w *= 2;
                    }

                    if (largeImg.w == gallery.currItem.w && largeImg.h == gallery.currItem.h) {
                        // console.log('%c _loadLargeImgIfMust', 'color: #B47400', 'Large Large image is not present or already set. Staying with medium.');
                        return;
                    }

                    sizeRatio = (currItem.w * currZoom) / largeImg.w;

                    gallery.currItem.w = largeImg.w;
                    gallery.currItem.h = largeImg.h;
                } else {
                    return;
                }
            } else {
                if (typeof currItem.cover !== 'undefined' || typeof currItem.appPromoSlide !== 'undefined') {
                    return;
                }

                largeImg = jsonData.originalItems[currItem.inx].largeImage;

                if (largeImg.w == gallery.currItem.w && largeImg.h == gallery.currItem.h) {
                    // console.log('%c _loadLargeImgIfMust', 'color: #B47400', 'Large image is not present or already set. Staying with medium.');
                    return;
                }


                sizeRatio = (currItem.w * currZoom) / largeImg.w,
                    gallery.currItem.w = largeImg.w;
                gallery.currItem.h = largeImg.h;
                gallery.currItem.src = largeImg.src;
            }
            largeZoom = sizeRatio;

            gallery.currItem.largeZoomed = true;
            gallery.setImageSize(gallery.currItem, false, true, true);
            gallery.updateSize(true);

            if (isMobile) {
                gallery.zoomTo(largeZoom);
            } else {
                var cPoint = gal.gallery.getCurrCenterPoint();

                gallery.zoomTo(largeZoom, cPoint);
            }
        }
    }

    function _handleCounterDisplay() {
        var fRatio = gallery.currItem.fitRatio,
            zLvl = gallery.getZoomLevel();
        if (fRatio < zLvl) {
            $('.pswp__counter').css({ opacity: 0 });
            $('#view-main-wrapper').addClass('custom-zoomed-in');
            $('#view-main-wrapper .slider-pin-zone.pin-zone-animated').removeClass('pin-zone-animated');
            $(".word-single-pin.word-highlighted-pin").removeClass("word-highlighted-pin");
            $(".word-single-pin").addClass("wp-scaled");
        } else {
            $('.pswp__counter').css({ opacity: 1 });
            $('#view-main-wrapper').removeClass('custom-zoomed-in');
            $('#view-main-wrapper .slider-pin-zone').addClass('pin-zone-animated');
            $(".word-single-pin").removeClass("wp-scaled");
        }
    }


    function _handleXmlTextSize() {
        if((viewSettings.isRedesign === false || typeof viewSettings.isRedesign === "undefined")){
            setTimeout(_handleXmlElipsis, 10);
        }
        if (viewSettings.isRedesign === true) {
            return;
        }
        $('#slider-wrapper').find('.p-title, .p-btn-label').not('.w-half .p-title').fitText();
        $('#slider-wrapper').find('.w-half .p-title').fitText(1.2);
        $('#slider-wrapper').find('.p-old-price').fitText(1.2);
        $('.p-hover-btn').fitText(1.1);
        $('.w-3 .p-text').fitText(4);
        $('.w-2 .p-text').fitText(3);
        $('.w-1 .p-text').fitText(1.75);
        // $('.w-half .p-text').fitText(0.5);
        
        // $(gallery.currItem.container).find('.p-title, .p-btn-label').fitText();
        // $('.p-title, .p-btn-label').multiLineEllipsis({line: 5});

    }

    function _handleXmlElipsis() {
        var currItem = gallery.currItem;

        if (!currItem.elipsis) {
            $(currItem.container).find('.p-title').each(function() {
                var rowH = Math.floor(helpers.calculateRowH($(this)));

                if ($(this).closest('.w-half').length) {
                    rowH = 2;
                } else {
                    if (rowH > 2) {
                        rowH -= 1;

                        if (rowH > 4)
                            rowH = 3;
                    }
                }

                $(this).multiLineEllipsis({ line: rowH });
            });

            currItem.elipsis = true;
        }
    }

    function _calcRelatedBrochuresSize() {
        var $bCover = $('#back-cover');

        if ($bCover.length == 0 || $bCover.find('.view-related').length == 0) {
            return;
        }

        var bCoverSize = $bCover[0].getBoundingClientRect(),
            bRelatedSize = $bCover.find('.view-related')[0].getBoundingClientRect();

        var hCountDoubleVal = bRelatedSize.width / 100;
        var vCountDoubleVal = bRelatedSize.height / 142;
        var hCount = (Math.round((hCountDoubleVal % 1) * 10) / 10) > 0.8 ? Math.round(hCountDoubleVal) : Math.floor(hCountDoubleVal);
        var vCount = (Math.round((vCountDoubleVal % 1) * 10) / 10) > 0.8 ? Math.round(vCountDoubleVal) : Math.floor(vCountDoubleVal);

        hCount = Math.min(hCount, 4);
        vCount = Math.min(vCount, 3);

        if (hCount == 0 || vCount == 0) {
            $bCover.find('.view-related .catalog').hide();
            return;
        } else {
            $bCover.find('.view-related .catalog').show();
        }

        var hWidth = 100 / hCount;
        var hHeight = 100 / vCount;

        $('.view-related .catalog').css({ width: hWidth + '%', height: hHeight + '%' });
        helpers.renderFix();
    }

    /* Used for lazy loading if images in html slides (double page mode) in photoswipe. */
    function _preLoadPageImgs() {
        var currInx = gallery.getCurrentIndex();

        bLazy.load(dom.getAll('.page .b-lazy'), true);

        return;
    }

    function _buildSliderData(data) {
        var options,
            pswpElement,
            frontCover,
            backCover,
            promoLastPage,
            promoSpecificLastPage;

        pswpElement = $('#slider-wrapper .pswp')[0];

        jsonData.relatedBrochures = false;

        if (typeof data.related_brochures !== 'undefined' && !!data.related_brochures && data.related_brochures.length > 0) {
            jsonData.relatedBrochures = data.related_brochures;
            jsonData.relatedBrochuresForProductPopup = data.related_brochures;
            _findFirstUnreadRelatedBrochure(jsonData);
        }

        if(typeof data.trackingBugs !== 'undefined' && typeof offerista_tracking !== "undefined" && offerista_tracking) {
            if (data.trackingBugs.length) {
                var offeristaTrackingPixel = new OfferistaTracking();
                
                data.trackingBugs.forEach(function(el) {
                    offeristaTrackingPixel.trackingPixel(el);
                });
            }
        }

        frontCover = _generateFrontCover();
        backCover = _generateBackCover(jsonData.relatedBrochures);
        promoLastPage = _generatePromoLastPage(lastPagePromo);
        promoSpecificLastPage = _generateSpecificPromoLastPage(specificPromoPage);


        _currentState.defaultMode = jsonData.mode = isMobile ? ViewConsts.single : data.mode;

        if (data.type === ViewConsts.xml) {
            mzView.cssFilters();

            var items = xmlSlides.getXmlData(data, frontCover, backCover, promoLastPage);

            jsonData.originalItems = items.slice();
            jsonData.singlePageItems = xmlSlides.buildSingleContent(items.slice(), frontCover, backCover, promoLastPage, false, promoSpecificLastPage);
            //jsonData.doublePageItems = xmlSlides.buildDoubleContent(items.slice(), frontCover, backCover, promoLastPage, false, promoSpecificLastPage, _generateRelatedBrochuresPage());

            jsonData.type = ViewConsts.xml;
        } else {
            images = _translateObjects(data);

            jsonData.originalItems = images.slice();
            jsonData.singlePageItems = _buildSingleContent(images, frontCover, backCover, promoLastPage, false, promoSpecificLastPage);
            //jsonData.doublePageItems = _buildDoubleContent(images, frontCover, backCover, promoLastPage, false, promoSpecificLastPage);
        }


        //if (jsonData.mode === ViewConsts.single || isMobile) {
            jsonData.images = jsonData.singlePageItems.slice();
            _currentState.mode = ViewConsts.single;
        // } else {
        //     jsonData.images = jsonData.doublePageItems.slice();
        //     _currentState.mode = ViewConsts.double;
        // }

        _this.jsonData = jsonData;
        _currentState.currentPage = _getCurrentPage();

        options = {
            index: _currentState.currentPage,
            modal: false,
            loop: false,
            escKey: false,
            pinchToClose: false,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            tapToClose: false,
            mouseUsed: true,
            loop: false,
            transitionOnSlide: true,
            tapToToggleControls: false,
            mouseWheelZoom: true,
            clickToCloseNonZoomable: false,
            preload: [1, 3],
            maxSpreadZoom: 1.5,
            blockZoomClasses: ['.cover-slide', '.cover', '.block-zoom'],
            allowZoomClasses: ['app-promo-slide', 'double-page-slide'],
            allowZoomHtmlKeys: ['appPromoSlide', 'doublePageSlide', 'htmlSlide'],
            redirectInAction: "redirectInAction",
            isClickableElement: function(el) {
                if (gallery.currItem.container) {
                    if (_isHtmlSlide() === true && ($(el).closest('.cover-slide').length !== 0 ||
                            gallery.currItem.container.querySelectorAll('.app-promo-slide, .xml-slide').length === 0)) {
                        return true;
                    }
                }
            },
            getDoubleTapZoom: function(isMouseClick, el) {
                // console.log('getDoubleTapZoom:', el.tagName === 'A' || $(el).closest("#cover-front").length ? 0 : 1);
                return el.tagName === 'A' || $(el).closest("#cover-front").length ? 0 : 1;
            }
        };

        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, jsonData.images, options);

        pinZones = new PinZones(gallery, jsonData, _viewOptions);
        pinZones.init();

        gallery.listen('beforeResize', function() {
            _viewOptions.realViewporWtidth = gallery.viewportSize.x * window.devicePixelRatio;

            if (viewConfig.check('largeQuality') && _viewOptions.realViewportWidth < _viewOptions.largeImagesPixelTreshold) {
                // _viewOptions.useLargeImages = false;
                // _viewOptions.imageSrcWillChange = true;
            } else if (viewConfig.check('largeQuality') == false && _viewOptions.realViewportWidth >= _viewOptions.largeImagesPixelTreshold) {
                // _viewOptions.useLargeImages = true;
                // _viewOptions.imageSrcWillChange = true;
            }

            // Invalidate items only when source is changed and when it's not the first update
            if (_viewOptions.imageSrcWillChange && !_viewOptions.firstResize) {
                // invalidateCurrItems sets a flag on slides that are in DOM,
                // which will force update of content (image) on window.resize.
                gallery.invalidateCurrItems();
            }

            if (_viewOptions.firstResize) {
                _viewOptions.firstResize = false;
            }

            _viewOptions.imageSrcWillChange = false;

        });

        var debouncedCalcHtml = dom.debounce(_calcHtmlSlideSize, 50);

        // gettingData event fires each time PhotoSwipe retrieves image source & size
        gallery.listen('gettingData', function(index, item) {
            // console.log("gettingData:: _optoiconns.useLargeImages:", _viewOptions.useLargeImages);
            if (
                typeof item.html === 'undefined'
            ) {

                if (_viewOptions.useLargeImages) {
                    item.src = item.largeImage.src;
                    item.w = item.largeImage.w;
                    item.h = item.largeImage.h;
                } else {
                    item.src = item.mediumImage.src;
                    item.w = item.mediumImage.w;
                    item.h = item.mediumImage.h;
                }

                item.originalSize = { w: item.w, h: item.h };
            } else {
                debouncedCalcHtml();
            }
        });

        gallery.listen('beforeChange', function(skipSlides) {
            // console.log('beforeChange', skipSlides);

            var currInx = gallery.getCurrentIndex();

            pinZones.removeAll();

            // var bLazyImgsArr = $(gallery.items[gallery.getCurrentIndex()].container).find('.page .b-lazy').get();
            // bLazy.load(bLazyImgsArr, true);

            if (skipSlides > 0 && skipSlides < 2 && viewConfig.check('redirectForBanners') && jsonData.type !== ViewConsts.xml && window.location.hostname !== 'prospektecheck.de' && window.location.hostname !== 'aktuelleprospekte.at') {
                _redirectIfNeeded(currInx);
            }
        });

        //use setTimeout, otherwise gallery has not initialized and throws error
        setTimeout(function() {
            if (!gallery || !gallery.framework) {
                return;
            }

            gallery.framework.bind(gallery.scrollWrap, 'pswpTap', function(e) {
                // console.log('pswpTap');
                var el = e.detail.target;

                if ($(el).hasClass("slider-pin-zone")) {
                    el.doclick(e);
                } else if ($(el).closest(".slider-pin-zone").length > 0) {
                    $(el).closest(".slider-pin-zone").get(0).doclick(e);
                } else if ($(el).is('area') ||
                    $(el).hasClass('last-page-banner-wrap') ||
                    $(el).closest('.last-page-banner-wrap').length > 0 ||
                    $(el).hasClass('product-zone.active') ||
                    $(el).closest('.product-zone.active').length > 0) {
                    // TODO: add function to send ga events
                    if ($(el).closest('.product-zone').length ) {
                        if(viewSettings.isRedesign === false || typeof viewSettings.isRedesign === "undefined"){
                             fireEvent(window, 'view.xml.product.onclick', $(el).closest('.product-zone'));
                        }
                    } else if ($(el).is('area') && $(el).closest('.specific-promo-page').length > 0) {
                        fireEvent(window, 'view.specific.promo.page.onclick', el.href);
                    } else if ($(el).hasClass('last-page-banner-wrap') || $(el).closest('.last-page-banner-wrap').length > 0) {
                        if (typeof el.href === 'undefined' || el.href == "") {
                            el = $(el).closest('a')[0];
                        }

                        fireEvent(window, 'view.last.page.banner.onclick', el);
                    } else {
                        fireEvent(window, 'view.app.promo.page.onclick', el);
                        if (isMobile && $(el).is('area')) {
                            el.click();
                        }
                    }
                } else if (isMobile) {
                    fireEvent(window, 'view.navigation.toggleNav');
                }


                // console.log('tap', e, e.detail);
                // e.detail.origEvent  // original event that finished tap (e.g. mouseup or touchend)
                // e.detail.target // e.target of original event
                // e.detail.releasePoint // object with x/y coordinates of tap
                // e.detail.pointerType // mouse, touch, or pen
            });
        }, 10);

        gallery.listen('zoomGestureStarted', function() {
            if (_isHtmlSlide() === false) {

                if (pinZones.$pageZones.length) {
                    pinZones.$pageZones.css({ 'visibility': 'hidden' });
                }
            }

            // console.log('zoomGestureStarted');   
        });

        gallery.listen('zoomGestureEnded', function() {
            // console.log('zoomGestureEnded'); 

            if (_isHtmlSlide() === false) {
                pinZones.$pageZones.css({ 'visibility': 'visible' });
            }
        });

        gallery.listen('initialZoomInEnd', function() {
            var screenToItemRatio = window.innerWidth / gal.gallery.currItem.w;

            if (screenToItemRatio > 1.5) {
                if (_isDoubleMode()) {
                    gallery.options.maxSpreadZoom = screenToItemRatio;
                } else if (screenToItemRatio > 2.5) {
                    gallery.options.maxSpreadZoom = screenToItemRatio;
                }
            }

            _preLoadPageImgs();

            fireEvent(window, 'view.initialZoomInEnd');
            // console.log("initialZoomInEnd");
            firstImgSlide = _firstImgSlide(gallery);
            _viewOptions.isInitialZoomed = true;

            if (_isHtmlSlide()) {
                _calcHtmlSlideSize();
                //TODO check event for cover forms
            }

            if (_isAtStart()) {
                if (_isDoubleMode()) {
                    // console.log('%c ui.cover.front.show', 'color: orange');
                    // TODO uncomment this
                    fireEvent(window, 'ui.cover.front.show');
                }
                fireEvent(window, 'view.first.page.show');
            }

            if (isMobile) {
                if (gallery.getCurrentIndex() == jsonData.singlePageItems.length - 1) {
                    fireEvent(window, 'view.last.page.show');
                }
            } else {
                if (_isAtEnd()) {
                    fireEvent(window, 'view.last.page.show');
                }
            }


            window.addEventListener('view.zones.load.initial', function() {
                setTimeout(function() {
                    pinZones.load(_isDoubleMode(), _isHtmlSlide());
                }, 300);

                window.removeEventListener('view.zones.load.initial', function() {
                    pinZones.load(_isDoubleMode(), _isHtmlSlide());
                });
            });
            _handleFrontCover();
            setTimeout(_resizePageButtons, 10);

            var debouncedCalcHtmlAfterChange = dom.debounce(_calcHtmlSlideSize, 50);
            gallery.listen('afterChange', function(skipSlides) {
                // console.log('afterChange');
                _currentState.currentPage = gallery.getCurrentIndex();

                _preLoadPageImgs();

                if (gallery.options.redirectInAction && _currentState.currentPage == gallery.items.length - 1) { //because of added slide substract 2
                    if (isMobile && _relatedBrochureLoaded) {
                        window.location.href = viewSettings.relatedBrochure.brochure_link;
                    }
                }

                if (_isAtStart()) {
                    if (_isDoubleMode()) {
                        fireEvent(window, 'ui.cover.front.show');
                    }

                    fireEvent(window, 'view.first.page.show');
                }

                if (isMobile) {
                    if (gallery.getCurrentIndex() == jsonData.singlePageItems.length - 1) {
                        setTimeout(_calcRelatedBrochuresSize, 1);
                        if (_isAtEnd() && _relatedBrochureLoaded == false && typeof viewSettings.relatedBrochure !== undefined && typeof viewSettings.relatedBrochure.id !== undefined) {
                            _loadNextBrochure(viewSettings.relatedBrochure.id);
                        }

                        fireEvent(window, 'view.last.page.show');
                    }
                } else {
                    if (_isAtEnd()) {
                        //setTimeout(_calcRelatedBrochuresSize, 1);

                        fireEvent(window, 'view.last.page.show');
                    }
                }

                fireEvent(document, 'view.slider.zoom');
                fireEvent(window, 'view.onpagechange');

                // if(_isHtmlSlide()){
                debouncedCalcHtmlAfterChange();
                //TODO check event for cover forms
                // }

                if (jsonData.type === ViewConsts.xml) {
                    _handleXmlTextSize();
                }

                _handleCounterDisplay();
                _handleImageMaps();

                pinZones.load(_isDoubleMode(), _isHtmlSlide());
            });

            var debouncedSetImageSizeCallback = dom.debounce(function() {
                _handleImageMaps();

                if (jsonData.type == ViewConsts.xml) {
                    _handleXmlTextSize();
                }

                pinZones.handleZoom(_isDoubleMode(), _isHtmlSlide());

                _handleFrontCover();
            }, 100);

            gallery.listen('_setImageSize', function() {
                debouncedSetImageSizeCallback();
            });

            var debouncedResizeCallback = dom.debounce(function() {
                // console.log('%cdebounced resize', "color: orange");
                if (jsonData.type != ViewConsts.xml) {}
                pinZones.handleZoom(_isDoubleMode(), _isHtmlSlide());

                _handleFrontCover();
                helpers.renderFix();
            }, 100);

            gallery.listen("resize", function() {
                debouncedResizeCallback();
            });
        });

        gallery.listen('firstTouchStart', function(touches, zoomLevel, _isDragging) {
            // console.log("firstTouchStart", touches, _isDragging /*gal.gallery.isDragging()*/);
        });

        // gallery.listen('pointerDown', function(touches, zoomLevel) {
        //     console.log("pointerDown", touches);
        // });

        // gallery.listen('pointerUp', function() {
        //     console.log("pointerUp, isDragging:", gallery.isDragging());
        // });


        // gallery.listen('imageLoadComplete', function(skipSlides){
        //     console.log('imageLoadComplete');            
        // });


        gallery.listen('customZoomToStart', function(e) {
            $('#slider-wrapper .slider-pin-zone').hide();
            _handleFrontCover(0, true);
            // console.log('customZoomToStart');
        });

        var _customZoomToEndDebounced = dom.debounce(function() {
            $('#slider-wrapper .slider-pin-zone').show();

            if (jsonData.type !== ViewConsts.xml) {
                _loadLargeImgIfMust();
            }

            _handleFrontCover(0);

            fireEvent(document, 'view.slider.zoom');
        }, 100);

        gallery.listen('customZoomToEnd', function(e) {
            // console.log('customZoomToEnd');
            _handleCounterDisplay();
            _customZoomToEndDebounced();
        });

        gallery.listen('wheelZoomStart', function(direction) {
            // console.log("wheelZoomStart", direction);
            var currZoom = gallery.getZoomLevel();

            _zoomInProgress = true;
            _handleFrontCover(0, direction == -1 ? true : false);

            if (currZoom != gallery.options.maxSpreadZoom && currZoom != gallery.currItem.fitRatio) {
                $('#slider-wrapper .slider-pin-zone').hide();
            }
        });

        var _wheelZoomEndDebounced = dom.debounce(function() {
            // console.log('wheelZoomEnd');
            _zoomInProgress = false;
            $('#slider-wrapper .slider-pin-zone').show();

            if (jsonData.type !== ViewConsts.xml) {
                _loadLargeImgIfMust();
            }

            fireEvent(document, 'view.slider.zoom');
        }, 150);

        gallery.listen('wheelZoomEnd', function(e) {
            _handleFrontCover(0);
            _handleCounterDisplay();
            _wheelZoomEndDebounced();
        });

        gallery.listen('mainScrollAnimStart', function() {
            _resizePageButtons();

            if (typeof navigation !== 'undefined' && typeof navigation.navIsOpen !== 'undefined' && navigation.navIsOpen() && _isAtEnd() === false) {
                navigation.toggleNav();
            }
        });

        gallery.listen('mainScrollAnimComplete', function() {
            // console.log('mainScrollAnimComplete');

            _handleFrontCover();
        });

        gallery.listen('goTo', function(_currentItemIndex) {
            // console.log('goto::', _currentItemIndex);
            setTimeout(function() {
                _resizePageButtons();
            }, 0);
            // if (_currentItemIndex != 0) {
            //     _hideFrontCover();
            // } else {
            //     _handleFrontCover(0);
            // }
        });

        gallery.listen('goToEnd', function(direction) {
            // console.log('%c goToEnd', 'color: green', direction);
            _handleFrontCover(0);
        });

        gallery.listen('removeTransitionOnSlide', function(direction) {
            // console.log('%c removeTransitionOnSlide', 'color: green', direction);
            _handleFrontCover();
        });

        gallery.listen('moveMainScroll', function(direction) {
            // console.log('%c moveMainScroll', 'color: green');
            _handleFrontCover(0);
        });

        gallery.listen('preventDragEvent', function(e, isDown, preventObj, eventType) {
            if (eventType == "_onDragStart" && isiOS) {
                preventObj.prevent = false;
            }

            if (eventType == "_onDragMove" && isiOS) {
                preventObj.prevent = false;
            }
            // console.log('%c e.type: ' + e.type, "color: red;");
        });

        window.Parsley.on('field:error', function() {
            // This global callback will be called for any field that fails validation.
            // console.log('Validation failed for: ', this.$element);
        });

        window.Parsley.addValidator('checkEmail', {
            requirementType: 'string',
            validateString: function(value, requirement) {
                var response = false;

                $.ajax({
                    type: "GET",
                    url: webpath + catalogDataUrl,
                    async: false,
                    success: function(data) {
                        if (data.mode == "double") {
                            response = true;
                        }

                        // console.log("response:", response);
                        return false;
                    },
                    error: function() {
                        // console.log("ajax error");
                    }
                });

                // console.log("response:", response);

                return response;
            },
            messages: {
                en: 'This value should be a valid email'
            }
        });

        _this.gallery = gallery;

        fireEvent(document, 'built_slider_data', {});
    }

    function _preloadSlider() {
        var url = catalogDataUrl + brochureId;

        _getData(url, _buildSliderData);
    }

    function _resizeSliderViewport() {
        if (isMobile) {
            var sideBarH = 0,
                mainMinH = 450,
                mainNewH = 0;

            if ($('#sidebar').length > 0) {
                sideBarH = $('#sidebar').outerHeight(true);

                /*initial test for Lithuania site OF-2101*/
                if (typeof site_lt !== 'undefined' && site_lt) {
                    // console.log('site_lt');
                    sideBarH = sideBarH > 100 ? 150 : sideBarH;
                }
            }
            
            mainNewH = window.innerHeight - ($(_viewHeaderSel).length ? $(_viewHeaderSel).outerHeight(true) : 0) - sideBarH;
            mainNewH = Math.max(mainNewH, mainMinH);
            
            if(typeof isTablet !=='undefined' && isTablet === true && (typeof viewSettings.isRedesign !== "undefined" && viewSettings.isRedesign === true)){
                $('#container-wrapper').height(mainNewH);
            }else{
                $(_mainSel).height(mainNewH);
            }
        }
    }

    function _isAdditionalPage(pageInx) {
        var isAddPage = false;

        if (_isDoubleMode()) {
            isAddPage = gal.jsonData.originalItems[pageInx].additional_page;
            // console.log('double page mode, ', isAddPage);
        } else {
            isAddPage = gal.gallery.currItem && gal.gallery.currItem.additional_page;
            // console.log('single page mode, ', isAddPage);
        }

        return isAddPage;
    }

    function _resizePageButtons() {
        if (gallery.currItem.container) {
            var htmlSlide = gallery.currItem.container.querySelector('.html-slide'),
                pageHeight = 400,
                scrollWrapBounds = _getScrollWrapBounds(),
                $viewBtnsWrap = $('.view-buttons-wrap');

            if (htmlSlide) {
                pageHeight = htmlSlide.clientHeight;
            } else {
                if (gallery.currItem.container.querySelectorAll('img').length == 0) {
                    return;
                }

                pageHeight = gallery.currItem.container.querySelector('img').clientHeight;
            }

            if (scrollWrapBounds.top < 100 && pageHeight > scrollWrapBounds.height - 40) {
                pageHeight = scrollWrapBounds.height - 40;
            }
            
            pageHeight = pageHeight > 300 ? pageHeight : 300;

            $viewBtnsWrap.css({ maxHeight: pageHeight + 'px' });

            $viewBtnsWrap.removeClass('hidden next-brochure');
            if (_isAtStart()) {
                $viewBtnsWrap.filter('.left').addClass('hidden');
            } else if (_isAtEnd()) {
                var addClassStr = 'next-brochure',
                    $vBWrapRight = $viewBtnsWrap.filter('.right');

                if ($vBWrapRight.hasClass('animated-end') === false) {
                    $vBWrapRight.find('.svg-arrow-icon').addClass('animated');
                }

                $vBWrapRight.addClass(addClassStr);

                setTimeout(function() {
                    $vBWrapRight.addClass('animated-end');
                }, 2550);
            }
        }
    }

    function _onOrientationChange(e){
        _resizeSliderViewport();
        gallery.updateSize(true);
    }

    function _handleOrientationChange(){
        var onOrientationChangeDebounced = dom.debounce(function(){
            _onOrientationChange();

            if(typeof VIEW_DEBUG !== 'undefined' && VIEW_DEBUG){
                console.log('orientation changed');
            }
        }, 350);

        // window.addEventListener('orientationchange', onOrientationChangeDebounced);
        $(window).on("orientationchange", onOrientationChangeDebounced);
    }

    function _loadNextRelOnTouchStart(e){
        if(typeof site_no !== 'undefined' && site_no === true && typeof isMobile !== 'undefined' && isMobile){
            $('.tablet .vr-related-bottom .vr-related-bottom__btn a').click();
        }

        $(document).off('touchstart', 'body', _loadNextRelOnTouchStart);
    }

    function _handleTouchStart(){
        $(document).on('touchstart', 'body', _loadNextRelOnTouchStart);
    }

    function _init() {
        _resizeSliderViewport();

        _preloadSlider();
        document.addEventListener('built_slider_data', function(e) {
            gallery.init();

            fireEvent(document, 'view.gallery.inited', {});

            var debouncedResizePageButtons = dom.debounce(_resizePageButtons, 50);

            window.addEventListener('resize', debouncedResizePageButtons);
            _handleOrientationChange();
            _handleTouchStart();
        });
    }

    function _reInit() {
        gallery.init();
    }


    _this.init = _init;
    _this.reInit = _reInit;
    // _this.removePins = pinZones.removeAll;
    // _this.loadPins = pinZones.load;
    _this.calcHtmlSlideSize = _calcHtmlSlideSize;
    _this.switchMode = _switchMode;
    _this.switchToSingleMode = _switchToSingleMode;
    //_this.switchToDoubleMode = _switchToDoubleMode;
    _this.currentState = _currentState;
    _this.loadNextBrochure = _loadNextBrochure;
    _this.isDoubleMode = _isDoubleMode;
    _this.viewOptions = _viewOptions;
    // _this.handleZoomPins = _handleZoomPins;
    _this.isAtStart = _isAtStart;
    _this.isAtEnd = _isAtEnd;
    // _this.isAtOriginalEnd = _isAtOriginalEnd;
    _this.getOriginalLastPageInx = _getOriginalLastPageInx;
    _this.handleFrontCover = _handleFrontCover;
    _this.resizePageButtons = _resizePageButtons;
    _this.handleCounterDisplay = _handleCounterDisplay;
    // _this.getAdditionalDoublePageImgSizeRatio = _getAdditionalDoublePageImgSizeRatio;
    _this.handleXmlElipsis = _handleXmlElipsis;
    _this.handleXmlTextSize = _handleXmlTextSize;
    _this.roundBy = _roundBy;
    _this.generateRelatedForBackCover = _generateRelatedForBackCover;
    _this.generateRelatedForBackCoverSecond = _generateRelatedForBackCoverSecond;
    _this.generateRelatedForRelatedPage = _generateRelatedForRelatedPage;
    _this.urlHasRedirectParam = _urlHasRedirectParam;
    _this.calcRelatedBrochuresSize = _calcRelatedBrochuresSize;
    _this.isAdditionalPage = _isAdditionalPage;
    _this.preLoadPageImgs = _preLoadPageImgs;
    _this.onOrientationChange = _onOrientationChange;
    _this.resizeSliderViewport = _resizeSliderViewport;
}